import { useAuth } from "@/features/auth/hooks/useAuth";
import type { ReactNode } from "react";

interface CanProps {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function Can({ permission, children, fallback = null }: CanProps) {
  const { hasPermission } = useAuth();

  return hasPermission(permission) ? <>{children}</> : <>{fallback}</>;
}
